import { httpGet, httpPost, httpJsonp } from '../../api/base';
import config from '../../config/config'
const url_pre = config.default_domin;

export default {
	getUserinfo(cb) {
		httpGet(`${url_pre}/api/fe/v1/private/p/Tools/getUserinfo`, null).then((res) => {
			if (!res) {
				cb({ errno: 110, error: '网络链接错误' })
			} else {
				if (res.data.errno == 0) {
					cb(res.data.body)
				} else {
					cb(res.data)
				}
			}
		})
	},
	// 获取人员列表
	getMemberList(params, cb) {
		httpGet(`${url_pre}/api/fe/v1/j/oms/member/list`, params).then((res) => {
			if (res.data) {
				cb(res.data.body)
			}
		})
	},
	getFreeCode(cb) {
		httpGet(`${url_pre}/api/fe/v1/private/p/saas/freeCode`, null).then((res) => {
			if (res.data) {
				cb(res.data.body.freeCode)
			}
		})
	}
}